import { Injectable } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { AddressFields } from '@com-delta-idp/mnx-login-ui';
import {
  city,
  district,
  prefecture,
  state,
  zipCode
} from '../../../validator/add-address-validator';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService {
  setValidator(
    transformedFields: AddressFields,
    formGroup: UntypedFormGroup
  ): void {
    if (transformedFields.addressLine3.required) {
      formGroup.controls.district.setValidators([
        Validators.required,
        district
      ]);
    } else {
      formGroup.controls.district.setValidators(null);
    }

    if (transformedFields.addressLine4.required) {
      formGroup.controls.city.setValidators([Validators.required, city]);
    } else {
      formGroup.controls.city.setValidators(null);
    }

    if (transformedFields.addressLine9.required) {
      formGroup.controls.postalCode.setValidators([
        Validators.required,
        zipCode
      ]);
    } else {
      formGroup.controls.postalCode.setValidators(null);
    }
    this.setValidatorHelper(transformedFields, formGroup);
  }

  setValidatorHelper(
    transformedFields: AddressFields,
    formGroup: UntypedFormGroup
  ): void {
    if (
      transformedFields.addressLine5.required &&
      transformedFields.addressLine5.visible
    ) {
      formGroup.controls.state.setValidators([Validators.required, prefecture]);
      formGroup.controls.state.setErrors({ error: 'SELECT_PREFECTURE' });
    } else {
      this.setValidatorHelperSupport(transformedFields, formGroup);
    }
    formGroup.controls.district.updateValueAndValidity();
    formGroup.controls.city.updateValueAndValidity();
    formGroup.controls.postalCode.updateValueAndValidity();
    formGroup.controls.state.updateValueAndValidity();
  }

  setValidatorHelperSupport(
    transformedFields: AddressFields,
    formGroup: UntypedFormGroup
  ): void {
    if (
      transformedFields.addressLine7.required &&
      transformedFields.addressLine7.visible
    ) {
      formGroup.controls.state.setValidators([Validators.required, state]);
      formGroup.controls.state.setErrors({ error: 'SELECT_STATE' });
    } else {
      formGroup.controls.state.setValidators(null);
      formGroup.controls.state.setErrors(null);
    }
  }
}
